import React from 'react';

interface BaseInputProps {
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
  placeholder?: string;
  className?: string;
  children?: React.ReactNode;
  variant?: 'simple' | 'tags' | 'autocomplete';
  size?: 'sm' | 'md';
  dynamicHeight?: boolean;
}

const BaseInput: React.FC<BaseInputProps & React.HTMLAttributes<HTMLDivElement>> = ({ 
  value, 
  onChange, 
  placeholder, 
  className = '', 
  children,
  variant = 'simple',
  size = 'md',
  dynamicHeight = false,
  ...rest
}) => {
  const containerPadding = size === 'sm' ? 'px-[12px] py-[5px]' : 'px-[12px] py-[12px]';
  const minHeight = size === 'sm' ? '30px' : '48px';
  
  const containerStyle = { minHeight };
    
  return (
    <div className={`relative ${className}`} {...rest}>
      <div 
        className={`base-input-container ${containerPadding} ${dynamicHeight ? 'dynamic-height' : ''}`} 
        style={containerStyle}
      >
        {children}
      </div>
    </div>
  );
};

export default BaseInput;
